import { RouteObject } from 'react-router-dom'
import ECCDashboardLayout from '../../../pages/Dashboard/ecc/ECCDashboardLayout'
import { lazy } from 'react'
import { tabNames } from '../../helpers'
import { centreMiddleware, redirectToDefaultLoader } from './helpers'
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner'
import { ECCLayout } from '../../../pages/Dashboard/ecc/ECCLayout'

const HomePage = lazy(() =>
    import('../../../pages/Dashboard/HomePage/ECCHomePage').then((m) => ({
        default: m.default,
    }))
)
const MyCentrePage = lazy(() =>
    import('../../../pages/Dashboard/MyCentrePage').then((m) => ({
        default: m.default,
    }))
)
const SettingsPage = lazy(() =>
    import('../../../pages/Dashboard/SettingsPage/SchoolSettingsPage').then(
        (m) => ({
            default: m.default,
        })
    )
)
const PageNotFound = lazy(() =>
    import('../../../components/ErrorFallback/PageNotFound').then((m) => ({
        default: m.default,
    }))
)

const eccRoutes: RouteObject = {
    path: 'centre',
    element: <ECCDashboardLayout />,
    children: [
        {
            index: true,
            loader: redirectToDefaultLoader,
            element: <LoadingSpinner />,
        },
        {
            path: ':centreId',
            middleware: [centreMiddleware],
            element: <ECCLayout />,
            children: [
                {
                    index: true,
                    element: <HomePage />,
                    handle: {
                        meta: {
                            title: 'Home - Spark Relief Teachers',
                            description: 'Manage your account here',
                        },
                    },
                },
                {
                    path: tabNames.app.centre.myCentre.index,
                    element: <MyCentrePage />,
                    handle: {
                        meta: {
                            title: 'My Centre - Spark Relief Teachers',
                            description: 'Coming soon!',
                        },
                    },
                },
                {
                    path: tabNames.app.centre.settings.index,
                    element: <SettingsPage />,
                    handle: {
                        meta: {
                            title: 'Settings - Spark Relief Teachers',
                            description: 'Update your basic information',
                        },
                    },
                },
                {
                    path: '*',
                    element: (
                        <PageNotFound
                            homeLink={`${tabNames.app.centre.index}`}
                        />
                    ),
                    handle: {
                        meta: {
                            title: 'Page not found - Spark Relief Teachers',
                        },
                    },
                },
            ],
        },
        {
            path: '*',
            element: <PageNotFound homeLink={`${tabNames.app.centre.index}`} />,
            handle: {
                meta: {
                    title: 'Page not found - Spark Relief Teachers',
                },
            },
        },
    ],
}
export default eccRoutes
